/* The help-layer's visible affordances, gated by surface (help-layer.md
   HL4/HR-B5) — ported from app.ts's iPanel/hint/aboutLine/opHint wrappers.
   Each returns an HTML STRING from the trusted help registry (help.ts), so the
   chrome renders them through dangerouslySetInnerHTML exactly as the vanilla
   shell dropped them into innerHTML. All are no-ops unless the About-Hermes
   feature is enabled on this surface. */
import { enabled, type Surface } from "../../../shared/features";
import { aboutThisPage, concept, help, HELP, type ConceptId } from "../../help";

const aboutOn = (surface: Surface): boolean => enabled("about-hermes", surface);

/* the ⓘ concept panel for a concept id (HL2) */
export const iPanel = (surface: Surface, id: ConceptId): string =>
  aboutOn(surface) ? concept(id) : "";

/* a hover title / hint by key (HL3) */
export const hint = (surface: Surface, id: string): string =>
  aboutOn(surface) ? help(id) : "";

/* the section's "About this page" disclosure (HL5) */
export const aboutLine = (surface: Surface, label: string): string =>
  aboutOn(surface) ? aboutThisPage(label) : "";

/* a File verb's hover, keyed by its first word — as an attribute fragment
   (` title="…"`), for HTML-string contexts. Unknown verbs get nothing. */
export const opHint = (surface: Surface, label: string): string =>
  hint(surface, `op-${(label.split(/[\s…]/)[0] ?? "").toLowerCase()}`);

/* the same verb hover as PLAIN TEXT, for a React `title` prop — undefined when
   the feature is off or the verb is unknown, so JSX omits the attribute */
export const opTitle = (surface: Surface, label: string): string | undefined => {
  if (!aboutOn(surface)) return undefined;
  return HELP[`op-${(label.split(/[\s…]/)[0] ?? "").toLowerCase()}`];
};
